(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sem-shampoo-content"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialise() {
    document.querySelectorAll('[data-sem-shampoo-pairing]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const variants = JSON.parse(root.querySelector('[data-sem-variants]').textContent);
      const scope = root.closest('[data-product-id]') || document;
      const formatter = new Intl.NumberFormat(root.dataset.locale, {style:'currency',currency:root.dataset.currency});
      function update(supplied) {
        const form = scope.querySelector('form[action*="/cart/add"]');
        const selectedId = form?.querySelector('[name="id"]')?.value;
        const chosenOptions = Array.from(scope.querySelectorAll('input[type="radio"][name^="options["]:checked,select[name^="options["]')).map(el => el.value);
        const variant = supplied && variants.find(v => v.id === supplied.id) || (chosenOptions.length && variants.find(v => v.options.length === chosenOptions.length && v.options.every((value,i) => value === chosenOptions[i]))) || variants.find(v => String(v.id) === String(selectedId));
        if (!variant) return;
        root.querySelector('[data-sem-variant]').textContent = variant.title;
        root.querySelector('[data-sem-shampoo-price]').textContent = formatter.format(variant.price / 100);
        root.querySelector('[data-sem-total]').textContent = formatter.format((variant.price + Number(root.dataset.conditionerPrice)) / 100);
      }
      document.addEventListener('variant:change', event => update(event.detail?.variant));
      scope.addEventListener('change', () => requestAnimationFrame(() => update()));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise); else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
  } catch(e) { console.error(e); }
})();

})();
